#import "./imageRevertPayload.gql"

mutation RevertUserImage($input: RevertUserImageInput!) {
  revertUserImage(input: $input) {
    ... on UserImage {
      ...ImageRevertPayload
      topicId
    }
    __typename
  }
}
